import gql from "graphql-tag";
import { useQuery, QueryHookOptions } from "@apollo/client";

export const GET_FEATURED_LIVE_GAMES = gql`
  query GetFeaturedLiveGames($regionId: String!) {
    getFeaturedGames(regionId: $regionId) {
      gameList {
        bannedChampions {
          championId
          pickTurn
          teamId
        }
        gameId
        gameLength
        gameMode
        gameQueueConfigId
        gameType
        mapId
        participants {
          bot
          championId
          profileIconId
          spellOneId
          spellTwoId
          riotUserName
          riotTagLine
          teamId
          tier
          rank
        }
      }
    }
  }
`;

export interface FeaturedGame {
  bannedChampions: Array<{
    championId: number;
    pickTurn: number;
    teamId: number;
  }>;
  gameId: number;
  gameLength: number;
  gameMode: number;
  gameQueueConfigId: number;
  gameType: string;
  mapId: number;
  participants: Array<{
    bot: boolean;
    championId: number;
    profileIconId: number;
    spellOneId: number;
    spellTwoId: number;
    riotUserName: string;
    riotTagLine: string;
    teamId: number;
    tier: string;
    rank: string;
  }>;
}

interface FeaturedGamesData {
  getFeaturedGames: {
    gameList: FeaturedGame[];
  };
}

export function useGetFeaturedLiveGames(region: string, queryOptions?: QueryHookOptions) {
  return useQuery<FeaturedGamesData>(GET_FEATURED_LIVE_GAMES, {
    ...(queryOptions || {}),
    variables: {
      regionId: region,
    },
  });
}
